import { Injectable } from '@angular/core';
import { DisplayItemTypeEnum } from '../../../../lib/display/display-item/display-item-type.enum';
import { DisplayItem } from '../../../../lib/display/display-item/display-item';
import { BaseGridWorkflowService } from '../base-grid-workflow.service';
import { RfidCardReaderService } from '../../../rfid-card/rfid-card-reader.service';
import { Subscription } from 'rxjs';

@Injectable()
export class RfidCardGridWorkflowService extends BaseGridWorkflowService {

  subsrcription: Subscription;
  private rfidCardReaderService: RfidCardReaderService;

  init(
  ) {
    super.init();
    this.rfidCardReaderService = this.injector.get(RfidCardReaderService);
  }

  get displayItemType(): DisplayItemTypeEnum {
    return DisplayItemTypeEnum.RfidCard;
  }

  show(displayItem: DisplayItem, context: any): void {
    super.show(displayItem, context);
    this.enableRfidCardScanned();
  }

  hide(displayItem: DisplayItem, context: any): void {
    super.hide(displayItem, context);
    this.disabledRfidCardScanned();
  }

  hideAll(): void {
    super.hideAll();
    this.disabledRfidCardScanned();
  }

  get isEnableRfidCardScanned(): boolean {
    return this.subsrcription != null;
  }

  enableRfidCardScanned() {
    if (this.isEnableRfidCardScanned) {
      return;
    }
    this.subsrcription = this.rfidCardReaderService.rfidCardScanned.subscribe((x: string) => this.onRfidCardScanned(x));
    this.rfidCardLedEnable(true);
  }

  disabledRfidCardScanned() {
    if (!this.isEnableRfidCardScanned) {
      return;
    }
    this.rfidCardLedEnable(false);
    if (this.subsrcription) {
      this.subsrcription.unsubscribe();
      this.subsrcription = null;
    }
  }

  private rfidCardLedEnable(value: boolean) {
    if (this.dispatcherService.vuHttp != null) {
      this.dispatcherService.vuHttp.rfidCardLedEnable(value);
    }
  }

  onRfidCardScanned(cardCode: string) {
    this.userActivity();
    if (!this.context) {
      return;
    }
    this.displayGridWorkflowService.updateContext({
      rfidCardCode: cardCode
    });

    this.navigateToUrlOrNavigationItem();
  }

  fillExternalApiRequestData(requestData: Map<string, any>, context: any) {
    if (context.rfidCardCode) {
      requestData.set('barcode', context.rfidCardCode);
    }
  }
}
